/**
 * 認證相關的工具函數 - 用於 Google OAuth
 */

export const isMobileDevice = (): boolean =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isOAuthStateError = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') return false;
    const msg = (error as { message?: string }).message || '';
    const code = (error as { code?: string }).code || '';
    return (
        msg.includes('missing initial state') ||
        msg.includes('sessionStorage') ||
        msg.includes('state parameter') ||
        code === 'auth/popup-closed-by-user' ||
        code === 'auth/cancelled-popup-request'
    );
};

export const getOptimalOAuthParams = () =>
    isMobileDevice()
        ? { prompt: 'select_account', access_type: 'online', include_granted_scopes: 'true' }
        : { prompt: 'consent', access_type: 'offline', include_granted_scopes: 'true' };

export const clearFirebaseSessionStorage = (): void => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            const keysToRemove: string[] = [];
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && (key.includes('firebase') || key.includes('auth') || key.includes('oauth') || key.includes('google'))) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((k) => sessionStorage.removeItem(k));
        }
    } catch (_) { /* ignore */ }
};

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const withRetry = async <T>(
    fn: () => Promise<T>,
    maxRetries: number = 2,
    delayMs: number = 1000,
    shouldRetry?: (error: unknown) => boolean
): Promise<T> => {
    let lastError: unknown;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await fn();
        } catch (error) {
            lastError = error;
            if (attempt === maxRetries || (shouldRetry && !shouldRetry(error))) throw error;
            await delay(delayMs * (attempt + 1));
        }
    }
    throw lastError;
};
